import Setting from "../../setting.js";
import PageHeader from "@/components/PageHeaderVenue.vue";
import VenueTitle from "@/components/VenueTitle.vue";
import VenueDescription from "@/components/VenueDescription.vue";
import VenueIntroduction from "@/components/VenueIntroduction.vue";
import Separator from "@/components/Separator.vue";
import VenueImages from "@/components/VenueImages.vue";
import VenueLabs from "@/components/VenueLabs.vue";
import VenueParticipants from "@/components/VenueParticipants.vue";
import Video from "@/components/Video.vue";
import Pdf from "@/components/Pdf.vue";
import VenueTip from "@/components/VenueTip.vue";
import VenueContact from "@/components/VenueContact.vue";
import ScenariosTable from "@/components/ScenariosTable.vue";
import Venues from "@/components/Venues.vue";

import Footer from "@/components/Footer.vue";

export default {
  name: "Venue2024SpringFall",
  components: {
    PageHeader,
    VenueTitle,
    VenueDescription,
    VenueIntroduction,
    Separator,
    VenueImages,
    VenueLabs,
    VenueParticipants,
    Video,
    Pdf,
    VenueTip,
    VenueContact,
    ScenariosTable,
    Venues,

    Footer,
  },
  data() {
    return {
      venues: null,
      venue: null,
      scenarios: null,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.axios
        .get(Setting[process.env.NODE_ENV].API + "Venue/GetAll", {
          params: {
            year: this.$route.meta.year,
          },
        })

        .then((response) => {
          if (this.$route.meta.seasonId == "SPRING") {
            this.venues = response.data.filter(
              (x) =>
                x.id == 49 ||
                x.id == 50 ||
                x.id == 51 ||
                x.id == 52 ||
                x.id == 53 ||
                x.id == 54 ||
                x.id == 55 ||
                x.id == 56
            );
          }

          if (this.$route.meta.seasonId == "FALL") {
            this.venues = response.data.filter(
              (x) =>
                x.id == 57 ||
                x.id == 58 ||
                x.id == 59 ||
                x.id == 60 ||
                x.id == 61
            );
          }
        });

      this.axios
        .get(Setting[process.env.NODE_ENV].API2023 + "Venue/GetOne", {
          params: {
            id: this.$router.getRoutes().find((x) => x.path == this.$route.path)
              .meta.id,
          },
        })
        .then((response) => {
          /*
          console.warn({
            data: response.data.data,
          });
          */

          this.venue = response.data.data;
        });

      this.axios
        .get(Setting[process.env.NODE_ENV].API + "Scenario/GetAllByVenue", {
          params: {
            id: this.$router.getRoutes().find((x) => x.path == this.$route.path)
              .meta.id,
          },
        })
        .then((response) => {
          this.scenarios = response.data;
        });
    },
  },
  watch: {
    $route(to, from) {
      /*
      console.warn({
        to,
        from,
      });
      */

      if (from.meta.type == "venue" && to.meta.type == "venue") {
        this.getData();
      }

      if (to.name == "Scenario") {
        //
      } else {
        // this.getData();
      }

      //}
    },
  },
};
